import styled from "styled-components";

export const SideDrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  // gap: 11.6px;
  padding: 12px 24px;
  border-bottom: 1px solid #e3eaf6;
  h3 {
    margin: 0;
    color: #2e374a;
  }
  .HeaderFilter {
    display: flex;
    gap: 11.6px;
  }
`;
export const SideDrawerContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  form {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .form {
    background-color: #f2f7ff;
  }
  .qcicon {
    height: 40px;
    width: 40px;
  }
  &.po-info-sidebar {
    & > form {
      flex: 1;
      height: unset !important;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
  .confirm-popup-options-heading {
    color: #4e586d;
    font-weight: 600;
    font-family: var(--themeFont);
    font-size: 16px;
  }
`;

export const SideDrawerSearch = styled.div`
  /*padding: 14px 14px;*/
  padding: 14px 24px;
  padding-bottom: 0;
`;

export const NoItemsFound = styled.div`
  width: 100%;
  height: 40px;
  background-color: #fff0d7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  .first-msg {
    color: #f35531;
  }
  .second-msg {
    color: #2f6eb6;
    cursor: pointer;
  }
`;
export const QuotePopupHeaderContainer = styled.div`
  img {
    width: 32px;
    height: 32px;
    /*border-radius: 50%;*/
  }
  .Timer {
    width: 28px;
    height: 28px;
  }
  display: flex;
  align-items: center;
  justify-content: center;

  h3 {
    margin: 0 12px;
  }
  .filter-img {
    width: 20px;
    height: 20px;
    border-radius: unset;
  }
  .cmr-notes-img {
    width: 40px;
    height: 40px;
  }
`;

export const Width100 = styled.div`
  width: 100%;
  &.d-flex-row-gap {
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    .tabsd {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
`;
export const Width50 = styled.div`
  width: 50%;
  &.d-flex-row-gap {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
  &.pb-10px {
    padding-bottom: 10px;
  }
  .multi-select.react-select__indicators {
    align-items: center !important;
  }
`;
export const FormBodyOverFlow = styled.div`
  &.pos-grid-container {
    .ag-theme-alpine {
      .ag-paging-panel {
        .ag-paging-page-summary-panel {
          display: none !important;
        }
      }
    }
  }
  &.scrollArea {
    padding: 24px;
  }
  &.responsive {
    @media screen and (min-width: 1544px) {
      width: 80%;
    }
  }
  .hi {
    padding: 16px 0px 13px 2px;
  }
  /* padding: 22px; */
  padding: 0px 24px;

  flex: 1;
  overflow: auto;
  /* padding-top: 22px; */
  &.warehouse-deatil {
    margin-top: 24px;
    padding: 0px !important;
  }
  &.flex-unset {
    flex: unset;
  }
  &.pb-zero {
    padding-bottom: 0;
  }
  &.overflow-unset {
    overflow: unset;
  }
  .client-options-list {
    font-size: 16px;
    color: var(--modelTitleColor);
    font-weight: bold;
    font-family: var(--themeFont);
  }
  .confirm-popup-options-heading {
    color: #4e586d;
    font-weight: 600;
    font-family: var(--themeFont);
    font-size: 15px;
  }
  &.side-bar {
    margin: 16px 0px;
    padding: 0px 25px;
    flex: 1;
    height: unset !important;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .header-align-left {
    .ag-header-cell-label {
      justify-content: end !important;
    }
  }
  .ag-header-justify-center {
    .ag-header-cell-label {
      justify-content: center !important;
    }
  }
  .header-justify-start {
    .ag-header-cell-label {
      justify-content: flex-start !important;
    }
  }
  .ag-header-cell {
    padding-right: 4px !important;
  }
`;
export const FilterFieldsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 16px;
  &:not(:first-child) {
    padding-top: 24px;
  }
  &.width {
    width: 100%;
  }
  &.full-width {
    width: 50% !important;
  }
  .qc-form-container {
    gap: 24px;
  }

  > div {
    width: 100%;
    margin: 0 4px;
  }
  row-gap: 16px;
  .current {
    display: flex;
    /*gap: 10pc;*/
    justify-content: space-between;
  }
  .pricings {
    display: flex;
    /*gap: 10pc;*/
    justify-content: space-between;
  }
  .gap-10 {
    gap: 10px;
  }
  .select-label {
    /* margin-bottom: 4px; */
  }
  svg {
    display: block !important;
  }
`;
export const SideDrawerFooter = styled.div`
  background-color: #fff;
  border-top: 1px solid var(--greyCardBorder);
  padding: 12px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  position: relative;
  &.sp-filter-footer-btns {
    border-top: unset;
    justify-content: flex-end;
    gap: 8px;
    button {
      height: 32px !important;
      width: calc(100% - 16px);
      /*padding-top: 2px;*/
      align-items: center;
      border-radius: 6px;
    }
  }
  .Decline {
    cursor: pointer;
    button {
      padding: 9px 26px;
      color: #dc4b43;
      border: 2px solid #dc4b43;
      border-radius: 3px;
      background: white;
      cursor: pointer;
    }
  }
  &.d-none {
    display: none;
  }
  &.padding-x-zero {
    padding-right: 0;
    padding-left: 0;
  }
  .server-msg {
    margin-right: auto;
  }
`;
